import React from "react";

const CustomModalHeaderStepper = ({ activeStep }) => {
  // Define the steps array here (can also be passed as props if needed)
  const steps = ["Add Project", "Shift", "Summary"];

  return (
    <div className="w-50 d-flex mx-auto my-5">
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          <div
            className={`stepper-circle ${index + 1 <= activeStep ? "active" : ""}  ${index === 1 ? "mx-4 " : "mx-2 "}`}
          >
            <div>
              <span>{index + 1}</span>
            </div>
            <div className="text-nowrap">{step}</div>
          </div>
          {index < steps.length - 1 && (
            <div className={`custom-hr ${index + 1 <= activeStep ? "active" : ""}`} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default CustomModalHeaderStepper;
